// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/sso.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { SsoService } from "./sso_pb";

/**
 * Creates a SCIM JWT token for the authenticated team
 *
 * @generated from rpc chalk.server.v1.SsoService.CreateScimToken
 */
export const createScimToken = SsoService.method.createScimToken;

/**
 * @generated from rpc chalk.server.v1.SsoService.ListSsoEmailDomains
 */
export const listSsoEmailDomains = SsoService.method.listSsoEmailDomains;

/**
 * @generated from rpc chalk.server.v1.SsoService.CreateSsoEmailDomain
 */
export const createSsoEmailDomain = SsoService.method.createSsoEmailDomain;

/**
 * @generated from rpc chalk.server.v1.SsoService.UpdateSsoEmailDomain
 */
export const updateSsoEmailDomain = SsoService.method.updateSsoEmailDomain;

/**
 * @generated from rpc chalk.server.v1.SsoService.DeleteSsoEmailDomain
 */
export const deleteSsoEmailDomain = SsoService.method.deleteSsoEmailDomain;

/**
 * @generated from rpc chalk.server.v1.SsoService.ListSignOnProviderConfigurations
 */
export const listSignOnProviderConfigurations = SsoService.method.listSignOnProviderConfigurations;

/**
 * @generated from rpc chalk.server.v1.SsoService.CreateSignOnProviderConfiguration
 */
export const createSignOnProviderConfiguration = SsoService.method.createSignOnProviderConfiguration;

/**
 * @generated from rpc chalk.server.v1.SsoService.UpdateSignOnProviderConfiguration
 */
export const updateSignOnProviderConfiguration = SsoService.method.updateSignOnProviderConfiguration;

/**
 * @generated from rpc chalk.server.v1.SsoService.DeleteSignOnProviderConfiguration
 */
export const deleteSignOnProviderConfiguration = SsoService.method.deleteSignOnProviderConfiguration;

/**
 * @generated from rpc chalk.server.v1.SsoService.GetSignOnProvidersForEmail
 */
export const getSignOnProvidersForEmail = SsoService.method.getSignOnProvidersForEmail;

/**
 * @generated from rpc chalk.server.v1.SsoService.GetSamlConfigurationByIssuer
 */
export const getSamlConfigurationByIssuer = SsoService.method.getSamlConfigurationByIssuer;
